// client/src/pages/PopupError.js
import { useEffect } from 'react';

const CLIENT_ORIGIN = process.env.REACT_APP_WEB_APP_URL || new URL(window.location.href).origin;

export default function PopupError() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get('error');
    const redirect = params.get('redirect') || 'signin';
    const targetUrl = `${CLIENT_ORIGIN}/${redirect}?error=${error}`;

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: 'auth-error', error, redirect },
        CLIENT_ORIGIN
      );
      const closeTimer = setTimeout(() => window.close(), 150);
      return () => clearTimeout(closeTimer);
    } else {
      // Fallback: opener lost, navigate this window to error page
      window.location.replace(targetUrl);
    }
  }, []);

  return null;
}
